import { useEffect } from 'react';

import { dataLayerPush } from '.';

let lastPercentage = 0;
let ticking = false;

export const GTMScrollDepth = () => {
  useEffect(() => {
    const onScrollCallback = () => {
      if (typeof window === 'undefined') {
        return;
      }
      const lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollableHeight =
            window.document.body.scrollHeight - window.innerHeight;
          if (scrollableHeight) {
            const percentage =
              (lastKnownScrollPosition / scrollableHeight) * 100;
            const percentageAsInteger = Math.floor(percentage / 25) * 25;
            if (lastPercentage !== percentageAsInteger && percentageAsInteger) {
              scrollDepthEventToGTM(percentageAsInteger);
              lastPercentage = percentageAsInteger;
            }
          }
          ticking = false;
        });

        ticking = true;
      }
    };
    document.addEventListener('scroll', onScrollCallback);
    return () => {
      document.removeEventListener('scroll', onScrollCallback);
    };
  }, []);

  return null;
};

const scrollDepthEventToGTM = (percentage: number) => {
  dataLayerPush({
    Category: 'Scroll Depth',
    Action: 'Scroll Depth',
    Label: `${percentage}%`, // i.e 25%, 50%, 75%, 100%
    noninteraction: `${percentage <= 50 ? true : false}`, // i.e 25% & 50% push true, else push false
    event: 'gaEvent',
  });
};
